var exports = {
  "k": "x93eb46d8--765562--container",
  "N": "x93eb46d8--765562--container_stretched",
};

module.exports = exports;
